import { Input } from "@heroui/react";
import { useTranslation } from "react-i18next";
import { DocumentEditor } from "src/components/editor/DocumentEditor";
import type { TDocumentContent } from "@shared/entities";
import type { TDocumentVariableKey } from "@shared/entities";
import type { EditorAdapterHandle } from "src/components/editor/types";

type Props = {
  content: TDocumentContent;
  title: string;
  variableKeys: readonly TDocumentVariableKey[];
  onReady: (handle: EditorAdapterHandle) => void;
  onChange: (content: TDocumentContent) => void;
  onTitleChange: (title: string) => void;
};

export function TemplateStep2({
  content,
  title,
  variableKeys,
  onReady,
  onChange,
  onTitleChange,
}: Props) {
  const { t } = useTranslation("doctorTemplates");

  return (
    <div className="flex flex-col gap-4">
      <Input
        label={t("templateTitle")}
        value={title}
        onValueChange={onTitleChange}
        placeholder={t("templateTitlePlaceholder")}
      />
      <DocumentEditor
        content={content}
        onChange={onChange}
        onReady={onReady}
        variables={variableKeys}
        placeholder={t("editorPlaceholder")}
        className="min-h-[300px]"
      />
    </div>
  );
}
